import type { SVGProps } from 'react';
const SvgTableRows = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#table_rows_svg__a)">
      <path
        fill="currentColor"
        d="M22 7H2V2h20v5Zm0 2.5H2v5h20v-5Zm0 7.5H2v5h20v-5Z"
      />
    </g>
    <defs>
      <clipPath id="table_rows_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTableRows;
